import { SearchMaterialNumberResponseData } from 'app/cross-cutting-concerns/communication/interfaces/am-sp-api-graphql';
import { Optional } from 'lib/types/Optional';

export const getMachineIsPairable = (
  materialNumberInput: Optional<string>,
  materialNumberList: Optional<SearchMaterialNumberResponseData[]>
): Optional<boolean> =>
  materialNumberList?.find(materialNumber => materialNumber.materialNumber === materialNumberInput)?.isPairable;
